import { FC } from "react"
import { Helmet } from "react-helmet-async"


export function Head() {
  return (
    <Helmet>
      <title>
        Название оборудования
      </title>
    </Helmet>
  )
}